// extracted by mini-css-extract-plugin
module.exports = {"container":"_2rWdn","left":"_2qwXo","wrapper":"_1Pz5a","titleWrapper":"_29Lx-","title":"_1T_rw","descriptionWrapper":"JxrVX","description":"_3PHqA"};